import {
  GET_AD_GROUP_LOCATIONS,
  GET_AD_GROUP_LOCATIONS_ERROR,
  GET_AD_GROUP_LOCATIONS_SUCCESS,
} from "./actionTypes"

export const getAdGroupLocations = payload => {
  return {
    type: GET_AD_GROUP_LOCATIONS,
    payload: payload,
  }
}

export const getAdGroupLocationsSuccess = locations => {
  return {
    type: GET_AD_GROUP_LOCATIONS_SUCCESS,
    payload: locations,
  }
}

export const getAdGroupLocationsError = error => {
  return {
    type: GET_AD_GROUP_LOCATIONS_ERROR,
    payload: error,
  }
}
